<template>
  <div>
    <NewGenericBTable
      :key="generic_key"
      :fields="fields"
      :url="'/mesh/alt-competence/'"
      :pre_filter="pre_filter"
      :show_pagination="true"
      :search_filter="true"
      :columns_display="true"
      :display_id="display_id"
      :sortDesc="sortDesc"
      :sortBy="sortBy"
      @actual_items="actualItems"
    >
      <template #cell(selected)="row">
        <b-checkbox
          :checked="selected.includes(row.item.id)"
          @change="selectCompetence(row.item.id, $event)"
        ></b-checkbox>
      </template>
      <template #cell(sentence)="row">
        <SentenceContainer :Sentence="row.item"> </SentenceContainer>
      </template>
      <template #cell(type)="row">
        <template v-for="type in [competenceType(row.item.type)]">
          <span
            v-if="type"
            v-b-tooltip.v-secondary="type.description"
            :key="type.id"
            >{{ type.name }}</span
          >
        </template>
      </template>
      <!-- Ciclo -->
      <template #cell(cycle_competence)="row">
        <b-form-select
          v-if="
            selected.includes(row.item.id) && competence_selections[row.item.id]
          "
          v-model="competence_selections[row.item.id].cycle"
          :options="egressProfileCycleSort"
          value-field="id"
          text-field="name"
          size="sm"
          :disabled="disable_cycle_select"
        >
          <template #first>
            <b-form-select-option :value="null">
              {{ $t("reusable.common.selectOption", { entity: "" }) }}
            </b-form-select-option>
          </template>
        </b-form-select>
        <b-form-select
          v-else
          :value="null"
          :options="egressProfileCycleSort"
          value-field="id"
          text-field="name"
          size="sm"
          disabled
        >
          <template #first>
            <b-form-select-option :value="null">
              {{ $t("reusable.common.selectOption", { entity: "" }) }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </template>
      <!-- Order -->
      <template #cell(order_competence)="row">
        <b-form-input
          v-if="
            selected.includes(row.item.id) && competence_selections[row.item.id]
          "
          type="number"
          v-model="competence_selections[row.item.id].order"
          min="1"
          size="sm"
        ></b-form-input>
        <b-form-input
          v-else
          type="number"
          :value="null"
          min="1"
          size="sm"
          disabled
        ></b-form-input>
      </template>
      <!-- Sub Order -->
      <template #cell(sub_order_competence)="row">
        <b-form-input
          v-if="
            selected.includes(row.item.id) && competence_selections[row.item.id]
          "
          type="number"
          v-model="competence_selections[row.item.id].sub_order"
          min="0"
          size="sm"
        ></b-form-input>
        <b-form-input
          v-else
          type="number"
          :value="null"
          min="0"
          size="sm"
          disabled
        ></b-form-input>
      </template>
    </NewGenericBTable>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "SelectedCompetence",
  components: {
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
  },
  props: {
    type_id: {
      default: null,
    },
    egress_profile_id: {
      default: null,
    },
    cycle_id: {
      default: null,
    },
    display_id: {},
    selected_competence_matrix: {
      type: Boolean,
      default: false,
    },
    default_order: {
      default: 1,
    },
    default_sub_order: {
      default: 0,
    },
    disable_cycle_select: {
      type: Boolean,
      default: false,
    },
    precursor_egress_profile_competence_id: {
      default: null,
    },
  },
  data() {
    return {
      selected: [],
      sortBy: "",
      sortDesc: false,
      actual_items: [],
      generic_key: 0,
      type_competence: "",
      options_type_competence: [],
      cycle_competence: null,
      options_cycle_competence: [],
      order_competence: 1,
      sub_order_competence: 0,
      // Almacenar las selecciones individuales de cada competencia
      competence_selections: {},
      precursor_competence_ids: [],
    };
  },
  computed: {
    ...mapGetters({
      competenceTypes: names.COMPETENCE_TYPES,
      profileCompetences: names.PROFILE_COMPETENCES,
      profile_cycles: names.PROFILE_CYCLES,
      cycles: names.CYCLES,
    }),
    competencesToExclude() {
      // Obtener IDs de competencias ya asociadas al perfil de egreso
      return this.profileCompetences
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .map((x) => x.competence);
    },
    pre_filter() {
      let filters = [];

      // En modo precursores: filtrar solo las competencias que trae el endpoint
      if (this.precursor_egress_profile_competence_id && this.cycle_id) {
        if (this.precursor_competence_ids.length > 0) {
          filters.push(`id__in=${this.precursor_competence_ids.join(",")}`);
        } else {
          // Aún cargando o sin resultados: no mostrar nada
          filters.push("id__in=0");
        }
        return filters.join("&");
      }

      // Filtrar por tipo de competencia si existe
      if (this.type_id) {
        filters.push(`type=${this.type_id}`);
      }

      // Excluir competencias ya asociadas al perfil de egreso
      if (this.competencesToExclude.length > 0) {
        filters.push(`id__exclude__in=${this.competencesToExclude.join(",")}`);
      }

      return filters.join("&");
    },
    egressProfileCycleSort() {
      if (!this.egress_profile_id) return [];
      let cycles = this.cycles.filter((cycle) =>
        this.profile_cycles
          .filter((pc) => pc.egress_profile == this.egress_profile_id)
          .map((pc) => pc.cycle)
          .includes(cycle.id)
      );

      cycles.forEach((cycle) => {
        let cycle_list = this.profile_cycles.find(
          (profile_cycle) =>
            profile_cycle.cycle == cycle.id &&
            profile_cycle.egress_profile == this.egress_profile_id
        );
        if (cycle_list) {
          cycle.init_semester = cycle_list.init_semester;
          cycle.end_semester = cycle_list.end_semester;
          cycle.order = cycle_list.order;
        }
      });

      const sortedCycles = cycles.sort(function (a, b) {
        if (a.init_semester < b.init_semester) return -1;
        if (a.init_semester > b.init_semester) return 1;
        if (a.end_semester < b.end_semester) return -1;
        if (a.end_semester > b.end_semester) return 1;
        return 0;
      });

      // Si selected_competence_matrix es true, excluir el último ciclo
      if (this.selected_competence_matrix && sortedCycles.length > 1) {
        // Remover el último elemento del array la cual es el ultimo ciclo
        return sortedCycles.slice(0, -1);
      }

      return sortedCycles;
    },
    fields() {
      let list = [
        {
          key: "selected",
          label: "",
          display_column: true,
          thStyle: { width: "1%" },
        },
        {
          key: "sentence",
          label: "Redacción",
          sortable: true,
          // La celda muestra full_sentence; sentence es calculado y no existe en la base
          ordering_key: "full_sentence",
          display_column: true,
        },
      ];
      // Mostrar columna tipo si algún elemento de la página actual tiene tipo
      if (this.actual_items.some((x) => x.type != null)) {
        list.push({
          key: "type",
          label: "Tipo",
          sortable: true,
          // La celda muestra el nombre del tipo de competencia, no su id
          ordering_key: "type__name",
          display_column: true,
        });
      }

      // Agregar columnas de que se usan en Matrix1
      if (
        this.selected_competence_matrix &&
        this.egressProfileCycleSort.length > 0
      ) {
        list.push({
          key: "cycle_competence",
          label: this.$getVisibleNames("mesh.cycle", false, "Ciclo Formativo"),
          display_column: true,
          thStyle: {
            width: "200px",
          },
        });
        list.push({
          key: "order_competence",
          label: this.$t("reusable.common.order"),
          display_column: true,
          thStyle: {
            width: "100px",
          },
        });
        list.push({
          key: "sub_order_competence",
          label: this.$t("curricularProducts.competence.subOrderLabel"),
          display_column: true,
          thStyle: {
            width: "100px",
          },
        });
      }
      return list;
    },
  },
  methods: {
    selectCompetence(competence_id) {
      const index = this.selected.findIndex((x) => x == competence_id);
      if (index != -1) {
        this.selected.splice(index, 1);
        // Limpiar la selección de esta competencia
        delete this.competence_selections[competence_id];
      } else {
        this.selected.push(competence_id);
        // Inicializar valores por defecto para esta competencia
        let defaultCycle;
        if (this.selected_competence_matrix) {
          defaultCycle =
            this.cycle_id ||
            (this.egressProfileCycleSort.length > 0
              ? this.egressProfileCycleSort[0].id
              : null);
        } else {
          defaultCycle = this.cycle_id;
        }

        // Calcular sub_order incrementando por cada competencia ya seleccionada
        const current_selection_count = Object.keys(
          this.competence_selections
        ).length;
        const computed_sub_order =
          this.default_sub_order > 0 || current_selection_count > 0
            ? this.default_sub_order + current_selection_count
            : 0;

        this.$set(this.competence_selections, competence_id, {
          cycle: defaultCycle,
          order: this.default_order,
          sub_order: computed_sub_order,
        });
      }

      // Si hay 2 o más seleccionadas y default_sub_order es 0,
      // el sub_order base debe ser 1 (no 0) para que todas queden con sub_order >= 1
      if (
        this.selected_competence_matrix &&
        this.disable_cycle_select &&
        this.default_sub_order == 0 &&
        this.selected.length > 1
      ) {
        Object.keys(this.competence_selections).forEach((id, index) => {
          this.competence_selections[id].sub_order = index + 1;
        });
      }

      // Emitir las selecciones con toda la información
      if (this.selected_competence_matrix) {
        this.$emit("slotUpdate", this.competence_selections);
      } else {
        this.$emit("slotUpdate", this.selected);
      }
    },
    competenceType(type_id) {
      return this.competenceTypes.find((x) => x.id == type_id);
    },
    actualItems(items) {
      // Actualizar los elementos de la página actual
      const has_type = items.some((x) => x.type != null);
      const had_type = this.actual_items.some((x) => x.type != null);

      this.actual_items = items;

      // NO inicializar competence_selections aquí
      // Solo se debe inicializar cuando el usuario selecciona el checkbox

      if (has_type != had_type) {
        this.generic_key++;
      }
    },
  },
  created() {
    // Cargar los ciclos si no están disponibles
    if (this.egress_profile_id) {
      this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
        egress_profile_id: this.egress_profile_id,
      });
      this.$store.dispatch(names.FETCH_CYCLES, this.egress_profile_id);
    }
    // En modo precursores: obtener IDs de competencias desde el endpoint
    if (this.precursor_egress_profile_competence_id && this.cycle_id) {
      this.$restful
        .Get(
          `/mesh/get_egress_profile_competence_precursors/?egress_profile_competence=${this.precursor_egress_profile_competence_id}&cycle=${this.cycle_id}`
        )
        .then((response) => {
          this.precursor_competence_ids = response.map((x) => x.competence_id);
          this.generic_key++;
        });
    }
  },
};
</script>

<style>
</style>